import React from 'react';

import { classNames } from '../../../../common/lib/classNames';

// Card frame around a datagrid: white background, gray border, rounded
// corners, subtle shadow. The grid inside should be borderless
// (commonConfig.headerStyle sets border: none).
export function DatagridCard({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={ classNames(
      `flex min-h-0 flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm`,
      className,
    ) }>
      { children }
    </div>
  );
}
